/* Nav panel: the list of steps, with one step pushed in over it. From the v15 prototype and the Figma frame
   "Desktop - 1" (Bend-Creator node 23:9580). Tokens come from the shell (`--bcs-*`). */
/* Sized by the visible pane, and shrinks to the panel's max height so a long step scrolls inside it. */
.track {
  position: relative;
  display: grid;
  /* minmax(0, …) stops the column growing to its content's min-content width, such as an input's default width. */
  grid-template-columns: minmax(0, 1fr);
  grid-template-rows: minmax(0, 1fr);
  min-height: 0;
  flex: 0 1 auto;
  /* Only animates while `useAnimatedPaneHeight` sets an explicit height. */
  transition: height 0.26s ease;
}

.pane {
  grid-area: 1 / 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  transition:
    transform 0.26s ease,
    opacity 0.22s ease;

  &[data-hidden] {
    position: absolute;
    inset: 0;
    opacity: 0;
    pointer-events: none;
  }
}

.rootPane[data-hidden] {
  transform: translateX(-30%);
}

.stepPane[data-hidden] {
  transform: translateX(100%);
}

@media (prefers-reduced-motion: reduce) {
  .track,
  .pane {
    transition: none;
  }
}

/* Root: one 70px row per step. */
.stepRow {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  height: 70px;
  padding: 10px 16px;
  border-bottom: 1px solid var(--bcs-gray-2);
  text-align: left;

  &:last-child {
    border-bottom: 0;
  }

  &:hover {
    background: var(--bcs-control-hover);
  }
}

.stepCircle {
  flex: 0 0 30px;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: 1px solid var(--bcs-gray-2);
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: var(--bcs-mono);
  font-size: 14px;
  color: var(--bcs-gray-7);

  &[data-done] {
    background: var(--bcs-shop-primary);
    border-color: var(--bcs-shop-primary);
    color: #fff;
  }

  &[data-error] {
    background: var(--mantine-color-red-8);
    border-color: var(--mantine-color-red-8);
    color: #fff;
    font-family: var(--bcs-sans);
    font-weight: 700;
  }
}

.stepText {
  flex: 1;
  min-width: 0;
  display: grid;
  gap: 5px;
}

.stepName {
  font-size: 16px;
  line-height: 1;
  color: var(--bcs-gray-6);
}

.stepTitle {
  font-size: 17px;
  font-weight: 500;
  line-height: 1.1;
  color: var(--bcs-gray-9);
}

.stepValue {
  font-family: var(--bcs-mono);
  font-weight: 500;
  font-size: 17px;
  line-height: 1.1;
  color: var(--bcs-gray-9);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-variant-numeric: tabular-nums;
}

.chevron {
  flex: 0 0 auto;
  color: var(--mantine-color-gray-5);
}

/* A pushed step: header · scrolling body · footer. */
.stepHeader {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: 6px;
  height: 64px;
  padding: 0 16px;
  border-bottom: 1px solid var(--bcs-gray-2);
}

.backButton {
  flex: 0 0 48px;
  width: 48px;
  height: 48px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--bcs-gray-7);

  &:hover {
    background: var(--bcs-control-hover);
  }
}

.headerText {
  flex: 1;
  min-width: 0;
  display: grid;
  gap: 3px;
}

.eyebrow {
  font-size: 12px;
  line-height: 1;
  letter-spacing: 0.2px;
  color: var(--bcs-gray-7);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.eyebrow[data-editing] {
  color: var(--bcs-shop-primary);
  font-weight: 600;
}

.headerTitle {
  font-size: 18px;
  font-weight: 600;
  line-height: 1.1;
  white-space: nowrap;
}

.stepBody {
  flex: 0 1 auto;
  min-height: 0;
  overflow-y: auto;
  padding: 16px;
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 20px;
  align-content: start;
}

.guidance {
  font-size: 14px;
  line-height: 1.45;
  color: var(--bcs-gray-7);
}

.stepFooter {
  flex: 0 0 auto;
  padding: 16px;
  border-top: 1px solid var(--bcs-gray-2);
  display: flex;
  gap: 8px;
}

.footerButton {
  flex: 1;
  height: 56px;
  font-size: 16px;
}
